<template>
  <div>
    <b-row class="mb-3">
      <b-col lg="4" md="6" xs="12">
        <b-form-datepicker @input="inputChanged" v-model="initialDate" class="mb-2"></b-form-datepicker>
      </b-col>
      <b-col lg="4" md="6" xs="12">
        <b-form-datepicker @input="inputChanged" v-model="lastDate" :min="minLastDate" class="mb-2"></b-form-datepicker>
      </b-col>
      <b-col lg="4" md="6" xs="12">
        <b-button class="mb-2" variant="default" v-b-modal.modal-sucursals block>Sucursales: {{ sucursals.length }} Seleccionadas</b-button>
      </b-col>
      <b-col lg="12" md="6" xs="12">
        <b-button variant="success" @click="changeDate" block>Buscar</b-button>
      </b-col>
    </b-row>
    <b-modal ok-only id="modal-sucursals" @ok="inputChanged" title="Sucursales" size="lg">
      <b-row>
        <b-col>
          <b-button-group>
            <b-button variant="success" @click="selectAllsucursals()">Seleccionar todo</b-button>
            <b-button variant="danger" @click="sucursals = []">Quitar seleccion</b-button>
          </b-button-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <div v-for="company in groupedSucursals" :key="company.name" class="mb-3">
            <div class="d-flex align-items-center mb-2">
              <b-form-checkbox
                :checked="isCompanyFullySelected(company)"
                :indeterminate="isCompanyPartiallySelected(company)"
                @change="toggleCompany(company, $event)"
                class="font-weight-bold"
              >
                <strong>{{ company.name }}</strong>
                <b-badge variant="secondary" class="ml-2">{{ getCompanySelectedCount(company) }}/{{ company.sucursals.length }}</b-badge>
              </b-form-checkbox>
            </div>
            <div class="ml-4">
              <b-form-checkbox
                v-for="suc in company.sucursals"
                :key="suc.id"
                :value="suc.id"
                v-model="sucursals"
                class="d-block"
              >
                {{ suc.nombre }}
              </b-form-checkbox>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import moment from 'moment';


export default {
  name: "ReportSearchBar",
  watch: {
    initialDate(i) {
      this.minLastDate=moment(i).format()
      // this.minLastDate = moment(i).add(1, 'days').format()
      if (moment(this.initialDate).isAfter(moment(this.lastDate))) {
        this.lastDate = null
      }
    },
    init(e){
      this.init=e
      this.initialDate = moment(this.init).format()
    },
    end(e){
      this.end=e
      this.lastDate = moment(this.end).format()
    },
    sucursales(e){
      this.sucursales=e
      this.sucursals=e.split(",").map(id => parseInt(id, 10)).filter(id => !isNaN(id))
    }
  },
  props: {
    emitOnStart: {
      type:Boolean,
      default: true
    },
    emitOnChange: {
      type:Boolean,
      default: true
    },
    //props
    init: {
      type:[String,Date],
      default: null,
      Required:false
    },
    end:{
      type:[String,Date],
      default: null,
      Required:false
    },
    sucursales:{
      type:[String,Int32Array],
      default: null,
      Required:false
    },
  },
  data() {
    return {
      allSucsArray: [],
      initialDate: null,
      lastDate: null,
      minLastDate: null,
      sucOptions: [],
      sucursals: [],
      groupedSucursals: []
    };
  },
  mounted() {
    console.log("reportDatesMounted")
    moment().locale("es-mx")
    if(typeof(this.sucursales)=="string"){
      this.sucursals=this.sucursales.split(",").map(id => parseInt(id, 10)).filter(id => !isNaN(id))
    }
    if(this.init!=null && this.end!=null){
      console.log("dates found")
      console.log(this.init)
      console.log(this.end)
      this.initialDate = moment(this.init).format()
      this.lastDate = moment(this.end).format()
    }else{
      this.initialDate = moment().subtract(7, "days").format()
      this.lastDate = moment().add(1, "days").format()
    }
    this.minLastDate = moment(this.initialDate).add(1, 'days').format()
    this.getSucursals()
  },
  methods: {
    selectAllsucursals() {
      let that = this
      this.sucursals = []
      this.sucOptions.forEach((element) => {
        that.sucursals.push(element.value)
      })
    },
    isCompanyFullySelected(company) {
      return company.sucursals.every(suc => this.sucursals.includes(suc.id))
    },
    isCompanyPartiallySelected(company) {
      const selectedCount = company.sucursals.filter(suc => this.sucursals.includes(suc.id)).length
      return selectedCount > 0 && selectedCount < company.sucursals.length
    },
    getCompanySelectedCount(company) {
      return company.sucursals.filter(suc => this.sucursals.includes(suc.id)).length
    },
    toggleCompany(company, checked) {
      if (checked) {
        company.sucursals.forEach(suc => {
          if (!this.sucursals.includes(suc.id)) {
            this.sucursals.push(suc.id)
          }
        })
      } else {
        company.sucursals.forEach(suc => {
          const index = this.sucursals.indexOf(suc.id)
          if (index > -1) {
            this.sucursals.splice(index, 1)
          }
        })
      }
    },
    getSucursals() {
      let that = this;
      axios
        .get("/sucursals")
        .then(function (response) {
          let l = response.data
          let fill = false
          if(that.sucursals.length == 0){
            fill = true
          }

          // Group by company
          const companyMap = {}
          l.forEach((element) => {
            const companyName = element.company_name || 'Sin empresa'
            if (!companyMap[companyName]) {
              companyMap[companyName] = {
                name: companyName,
                sucursals: []
              }
            }
            companyMap[companyName].sucursals.push(element)

            // Keep sucOptions for backward compatibility
            that.sucOptions.push({ text: element.nombre, value: element.id })
            if(fill){
              that.sucursals.push(element.id)
            }
          })

          // Convert to array and sort by company name
          that.groupedSucursals = Object.values(companyMap).sort((a, b) => a.name.localeCompare(b.name))

          // Sort sucursals within each company
          that.groupedSucursals.forEach(company => {
            company.sucursals.sort((a, b) => a.nombre.localeCompare(b.nombre))
          })

          if(that.emitOnStart){
            that.changeDate()
          }
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    changeDate() {
      console.log("changeDate")
      this.$emit("search",{sucursales: this.sucursals,initDate: this.initialDate,endDate:this.lastDate})
    },
    inputChanged(){
      if(this.emitOnChange){
        this.changeDate()
      }
      this.$emit("changed",{sucursales: this.sucursals,init: this.initialDate,end:this.lastDate})
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, {
        title,
        variant,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  }
}
</script>
